import axios from 'axios'

const state = { 
    admins: []
};

const getters = { 
    adminsList: state => state.admins
};

const actions = { 
    async fetchAdmins({commit},num=1){
        var url = process.env.VUE_APP_URL_API+'/auth/admin/all?page='+num;
        var token = window.localStorage.getItem('token');

        var params =  {
            headers: {
                Authorization: token,
            }
        }

        const response = await axios.get(url,params)
                            .catch(
                                error => {
                                    if (error.response.status === 401) {
                                        window.localStorage.removeItem('token');
                                        window.localStorage.removeItem('user');
                                        window.location.href = "/";
                                    }
                                    if (error.response.status === 404) {
                                        console.log('error 404, Endpoint no encontrado.')
                                    }
                                }
                            );

        commit("setAdmins", response.data.data);
    }
};

const mutations = { 
    setAdmins: (state, admins) => (
        state.admins = admins
    )
};

export default {
    state,
    getters,
    actions,
    mutations
}